import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useTheme } from '@material-ui/core/styles';
import React__default, { useState, useEffect } from 'react';

function Progress(props) {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handle = setTimeout(
      () => setIsVisible(true),
      theme.transitions.duration.short
    );
    return () => clearTimeout(handle);
  }, [theme.transitions.duration.short]);
  return isVisible ? /* @__PURE__ */ React__default.createElement(LinearProgress, { ...props, "data-testid": "progress" }) : /* @__PURE__ */ React__default.createElement(Box, { display: "none" });
}

export { Progress };
//# sourceMappingURL=Progress.esm.js.map
